import { createDecorator } from '../../../platform/instantiation/common/instantiation.js';
export var ITextResourceConfigurationService = createDecorator('textResourceConfigurationService');
export var ITextResourcePropertiesService = createDecorator('textResourcePropertiesService');
